// extracted by mini-css-extract-plugin
export default {"howToPlayVideo":"styles_howToPlayVideo__lB5k0","videoIframe":"styles_videoIframe__DR7M-"};